import React from 'react';
import { useConfig } from '../../ConfigContext';

export default function SocialsPanel() {
  const { socials, setSocialsState } = useConfig();

  return (
    <div>
      <div>
        <label className="custom-label">Název účtu</label>
        <input
          className={`w-full p-2`}
          value={socials.name}
          onChange={(e) => setSocialsState({ name: e.target.value })}
          placeholder="Zadejte název účtu"
        />
      </div>

      {/* Malý text */}
      <div>
        <label className="custom-label">Popisek</label>
        <input
          className={`w-full p-2`}
          value={socials.description}
          onChange={(e) => setSocialsState({ description: e.target.value })}
          placeholder="Např. Nejlepší fotka"
        />
      </div>

      <div>
        <label className="custom-label">To se líbí:</label>
        <input
          className={`w-full p-2`}
          value={socials.likesTag}
          onChange={(e) => setSocialsState({ likesTag: e.target.value })}
          placeholder="Např. Nejlepší fotka"
        />
      </div>

      <div>
        <label className="custom-label">A dalším...</label>
        <input
          className={`w-full p-2`}
          value={socials.likesOthersCount}
          onChange={(e) =>
            setSocialsState({ likesOthersCount: e.target.value })
          }
          placeholder="Zadejte název účtu"
        />
      </div>

      <div className="flex items-center gap-2 mt-1">
        <label
          className="inline-flex items-center me-5 cursor-pointer"
          htmlFor="socials-stats-checkbox"
        >
          <input
            type="checkbox"
            value=""
            className="sr-only peer"
            id="socials-stats-checkbox"
            checked={socials.useCustomStats}
            onChange={(e) =>
              setSocialsState({ useCustomStats: e.target.checked })
            }
          />
          <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
          <span className="ms-3 text-md font-medium">Vlastní statistiky</span>
        </label>
      </div>

      {socials.useCustomStats && (
        <div className="flex justify-between">
          <div>
            <label className="custom-label">Liků:</label>
            <input
              type="number"
              min={0}
              className={`w-full p-2`}
              value={socials.likes}
              onChange={(e) => setSocialsState({ likes: e.target.value })}
              placeholder="Počet Liků"
            />
          </div>
          <div>
            <label className="custom-label">Komentářů:</label>
            <input
              type="number"
              min={0}
              className={`w-full p-2`}
              value={socials.comments}
              onChange={(e) => setSocialsState({ comments: e.target.value })}
              placeholder="Počet komentářů"
            />
          </div>
          <div>
            <label className="custom-label">Sdílení:</label>
            <input
              type="number"
              min={0}
              className={`w-full p-2`}
              value={socials.shares}
              onChange={(e) => setSocialsState({ shares: e.target.value })}
              placeholder="Počet Sdílení"
            />
          </div>
        </div>
      )}

      <div className="flex justify-left my-2">
        <div className="flex items-center gap-2 mt-1">
          <label
            className="inline-flex items-center me-5 cursor-pointer"
            htmlFor="socials-like-checkbox"
          >
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              id="socials-like-checkbox"
              checked={socials.isLiked}
              onChange={(e) => setSocialsState({ isLiked: e.target.checked })}
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">Like</span>
          </label>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <label
            className="inline-flex items-center me-5 cursor-pointer"
            htmlFor="socials-verified-checkbox"
          >
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              id="socials-verified-checkbox"
              checked={socials.isVerified}
              onChange={(e) =>
                setSocialsState({ isVerified: e.target.checked })
              }
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">Ověřený účet</span>
          </label>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <label
            className="inline-flex items-center me-5 cursor-pointer"
            htmlFor="socials-storyActive-checkbox"
          >
            <input
              type="checkbox"
              value=""
              className="sr-only peer"
              id="socials-storyActive-checkbox"
              checked={socials.isActiveStory}
              onChange={(e) =>
                setSocialsState({ isActiveStory: e.target.checked })
              }
            />
            <div className="relative w-11 h-6 bg-gray-200 rounded-full peer dark:bg-gray-700 peer-focus:ring-4 peer-focus:ring-purple-300 dark:peer-focus:ring-purple-800 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-0.5 after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-purple-600 dark:peer-checked:bg-purple-600"></div>
            <span className="ms-3 text-md font-medium">Aktivní příběh</span>
          </label>
        </div>
      </div>
    </div>
  );
}
